export default __webpack_public_path__ + "static/media/configuracao-horarios.407c0fd5.svg";